import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	sortButtonTooltip: {
		id: 'jql-builder-basic-order-by-select.order-by-field-picker.sort-button-tooltip',
		defaultMessage: 'Reverse order direction',
		description:
			'text that appears over the toggle sort direction button to change the sort direction for a specific field',
	},
	clearButtonTooltip: {
		id: 'jql-builder-basic-order-by-select.order-by-field-picker.clear-button-tooltip',
		defaultMessage: 'Remove field',
		description:
			'text that appears over the remove field button which will remove a field from the sorted fields when clicked',
	},
	clearButtonLabel: {
		id: 'jql-builder-basic-order-by-select.order-by-field-picker.clear-button-label',
		defaultMessage: 'Remove {field}',
		description: 'indicates for screen reader users that field that will be removed when clicked',
	},
	pickerLabel: {
		id: 'jql-builder-basic-order-by-select.order-by-field-picker.picker-label',
		defaultMessage: '{field} selected',
		description: 'Screen reader label for the currently selected field',
	},
});

export default messages;
